// Sample data - in a real app this would come from props or API
import logoWithoutText from "../../components/assets/logo-without-text.svg";

export const carData = {
  images: [
    "https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480",
    "https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480",
    "https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480",
  ],
  vehicleInfo: {
    vin: "5UXTY5C00LL138420",
    location: "Brantford",
    year: "2020",
    make: "BMW",
    model: "X3",
    trim: "30i",
    transmission: "Automatic",
    odometer: "56,000",
    color: "Yellow",
    keys: "3",
    externalDamage: "Hail Damage,Dents",
    interiorDamage: "BLUETOOTH, HEATED STEERING WHEEL",
  },
  priceIndicators: [
    { label: "Low", value: 25105 },
    { label: "Average", value: 27704 },
    { label: "Awesome", value: 30304 },
  ],
  questions: [
    { question: "Do you smoke in this vehicle?", answer: "No" },
    { question: "Do you have original factory rims?", answer: "No" },
    {
      question: "Have you replaced your tires in last 12 month?",
      answer: "No",
    },
    { question: "Is your car drivable?", answer: "No" },
    { question: "Any crack on the windshield?", answer: "No" },
    { question: "Do you have any extended warranty?", answer: "No" },
    { question: "Are you interested in a trade in?", answer: "No" },
    { question: "Why are you selling?", answer: "No" },
    { question: "Describe the condition of the car", answer: "Good" },
    { question: "Any Accident Claims? How Much?", answer: "No" },
    { question: "What Rims Are On The Car?", answer: "After Market" },
    { question: "Do You Have Stock Rims?", answer: "No" },
    { question: "Any Issues With The Vehicle?", answer: "No" },
    { question: "Are There Any Modifications On The Car?", answer: "No" },
  ],
  bidHistory: [
    {
      bidderIcon: logoWithoutText,
      amount: 13000,
      dateTime: "2025-03-14 19:04:04",
    },
    {
      bidderIcon: logoWithoutText,
      amount: 13000,
      dateTime: "2025-03-14 19:04:04",
    },
    {
      bidderIcon: logoWithoutText,
      amount: 13000,
      dateTime: "2025-03-14 19:04:04",
    },
  ],
};

export const CAR_STATUS = {
  APPROVAL_PENDING: "approval_pending",
  LIVE_IN_AUCTION: "live-in-auction",
  LISTED_TO_AUCTION: "listed-in-auction",
  BUY_NOW: "Buy Now",
  LIST_TO_AUCTION: "List To Auction",
  IN_NEGOTIATION: "In negotiation",
  // UNSOLD_CAR: "Unsold Car",
  UNSOLD_CAR: "unsold-car",
  SOLD_CAR: "Sold Car",
  DRAFT: "Draft",
};

export const CAR_STATUSES = {
  approval_pending: "approval_pending",
  "listed-in-auction": "listed-in-auction", 
  "listed-to-auction": "listed-to-auction", 
  "live-in-auction": "live-in-auction", 
  "in-negotiation": "in-negotiation", 
};

export const CAR_STATUS_LABELS = {
  approval_pending: "Approval Pending",
  "live-in-auction": "Live in auction",
  "listed-in-auction": "Listed in auction",
  "listed-to-auction": "Listed to auction",
  BUY_NOW: "Buy Now",
  LIST_TO_AUCTION: "List To Auction",
  "in-negotiation": "In negotiation",
  UNSOLD_CAR: "Unsold Car",
  SOLD_CAR: "Sold Car",
  DRAFT: "Draft",
};

